module.exports = __webpack_public_path__ + "static/img/_zbjc.75a2cff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/icon/_zbjc.png
// module id = DaBH
// module chunks = 96